import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { WizardStep } from '../../../../../wizard/wizard.component';
import { StudyReportDeliveryEditInfo } from '../../../../../model/logistics/study-report/study-report-delivery-edit-info';
import { StudyReportDeliveryWizard } from '../../../../../services/wizard/logistic/study-report-delivery-wizard.service';

@Component({
  selector: 'app-study-report-delivery-detail',
  templateUrl: './study-report-delivery-detail.component.html',
  styleUrls: ['./study-report-delivery-detail.component.css']
})
export class StudyReportDeliveryDetailComponent implements OnInit, WizardStep {

  isInit: boolean;
  form: FormGroup;
  missingDocumentation: string[];
  @Input() studyReportDeliveryEditInfo: StudyReportDeliveryEditInfo;

  constructor(private notificationToastService: NotificationToastService
    , private studyReportDeliveryWizard: StudyReportDeliveryWizard
    , private formBuilder: FormBuilder) {
      this.form = this.formBuilder.group({
        Protocol: [{ value: '', disabled: true }]
        , PatientFullName: [{ value: '', disabled: true }]
        , PracticeRegionName:  [{ value: '', disabled: true }]
        , RegionName:  [{ value: '', disabled: true }]
        , Observation: [{ value: '', disabled: true }]
        , CdDelivery:  [{ value: '', disabled: true }]
        , PlatesDelivery:  [{ value: '', disabled: true }]
        , PlatesAmount: [{ value: '', disabled: true }]
        , DeliveryObservation: ['']
        , MedicalOrderAmount: [{ value: '', disabled: true }]
        , MedicalOrderState: [{ value: '', disabled: true }]
    });

    this.form.valueChanges.subscribe(() => {
        this.studyReportDeliveryWizard.setDeliveryObservation(
          this.form.controls.DeliveryObservation.value
        );
    });
  }

  get valid(): boolean {
    return this.completed;
  }

  get completed(): boolean { return !this.form.invalid; }
  get validMedicalOrderState(): boolean { return this.studyReportDeliveryEditInfo ?
    this.studyReportDeliveryEditInfo.ValidMedicalOrderState : false; }
  get validMedicalOrderAmount(): boolean { return this.studyReportDeliveryEditInfo ?
    this.studyReportDeliveryEditInfo.ValidMedicalOrderAmount : false; }

  activate(): void {
    this.studyReportDeliveryEditInfo =
      this.studyReportDeliveryWizard.getStudyReportDeliveryEditInfo();
    this.missingDocumentation = this.studyReportDeliveryEditInfo.MissingDocumentation;
    const deliveryState: string =
      this.validMedicalOrderAmount && this.validMedicalOrderState ? 'Entrega normal' : 'Orden o documentación incompleta';
    const cdDelivery: string =
      this.studyReportDeliveryEditInfo.CdDelivery ? 'Si' : 'No';
    const platesDelivery: string =
      this.studyReportDeliveryEditInfo.PlatesDelivery ? 'Si' : 'No';
    this.form.patchValue({
      Protocol: this.studyReportDeliveryEditInfo.Protocol
      , PatientFullName: this.studyReportDeliveryEditInfo.PatientView.LastName
      , PracticeRegionName: this.studyReportDeliveryEditInfo.PracticeRegionName
      , RegionName: this.studyReportDeliveryEditInfo.RegionName
      , Observation:  this.studyReportDeliveryEditInfo.Observation
      , DeliveryObservation: this.studyReportDeliveryEditInfo.DeliveryObservation
      , MedicalOrderAmount: this.studyReportDeliveryEditInfo.MedicalOrderAmount
      , MedicalOrderState: deliveryState
      , CdDelivery:  cdDelivery
      , PlatesDelivery: platesDelivery
      , PlatesAmount: this.studyReportDeliveryEditInfo.PlatesAmount
     });
  }

  save(): void {

  }

  ngOnInit(): void {
     this.isInit = true;
  }
}
